import type { AdminAuthProviderKind } from "../../contracts/admin-read-models";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";

function text(locale: AdminDashboardLocale, en: string, ko: string): string {
  return locale === "ko" ? ko : en;
}

export function formatAdminAuthProviderKindLabel(
  value: AdminAuthProviderKind | undefined,
  locale: AdminDashboardLocale,
): string {
  switch (value) {
    case "google":
      return text(locale, "Google", "Google");
    case "apple":
      return text(locale, "Apple", "Apple");
    case "unknown":
      return text(locale, "Unknown provider", "알 수 없는 provider");
    default:
      return "-";
  }
}
